<template>
  <transition name="fade">
    <div v-if="showLoadingOverlay" class="loading-overlay">
      <Spinner />
      <p class="h1 mb-0 text-white loading-text">
        {{ textLoading }}
      </p>
    </div>
  </transition>
</template>

<script>
import { mapGetters } from "vuex";
import Spinner from "../spinners/Spinner";

export default {
  components: {
    Spinner,
  },
  props: {
    textLoading: {
      type: String,
      required: true,
    }
  },
  computed: {
    ...mapGetters({
      showLoadingOverlay: "onboarding/getLoadingOverlayState",
    }),
  },
};
</script>

<style lang="scss" scoped>
@import "~styles/global";

.loading-overlay {
  position: fixed;
  width: 100%;
  height: 100%;
  background: $secondary-700;
  top: 0;
  left: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  padding: $spacer;
}

.loading-text {
  max-width: 20ch;
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity $transition-duration;
}

.fade-enter,
.fade-leave-to {
  opacity: 0;
}
</style>
